import { Injectable } from "@angular/core";
import { LoadingController, Platform } from "@ionic/angular";
import { Browser } from "@capacitor/browser";

@Injectable({
  providedIn: "root",
})
export class LinkService {
  constructor(private platform: Platform, public loadingCtrl: LoadingController) {}

  async openLink(link: string): Promise<void> {
    if (!link) {
      console.warn("No link provided to openLink.");
      return;
    }
    try {
      await Browser.open({ url: link });
    } catch (error) {
      console.error("Error opening link with Capacitor Browser: ", error);
    }
  }

  async openPDF(url: string): Promise<void> {
    if (!url) {
      console.warn("No URL provided to openPDF.");
      return;
    }
    try {
      await Browser.open({ url: url });
    } catch (error) {
      console.error("Error opening PDF: ", error);
    }
  }
}
